'use client'

import { Popover } from '@chaseweb/ui-library/src'

interface InlinePopoverProps {
  popoverText?: string
  variant?: string
  children: string
}

export const InlinePopover = ({
  popoverText,
  variant,
  children: popoverTrigger,
}: InlinePopoverProps) => {
  return popoverText ? (
    <Popover.Root>
      <Popover.Trigger variant={variant as undefined | 'secondary'}>
        {popoverTrigger}
      </Popover.Trigger>
      <Popover.Content side="top">
        {popoverText}
        <Popover.Close />
        <Popover.Arrow />
      </Popover.Content>
    </Popover.Root>
  ) : (
    popoverTrigger
  )
}
